export { default as customLogin } from "./customLogin/";
export { default as customLogout } from "./customLogout/";
export { default as getProduct } from "./getProduct/";
export { default as customRegister } from "./customRegister/";
export { default as customProfile } from "./customProfile/";
export { default as customCartLoad } from "./customCart/loadCart";
export { default as customAddCart } from "./customCart/addCart";
export { default as customUpdateCart } from "./customCart/updateCart";
export { default as customCartNum } from "./customCart/cartNum";
export { default as customCartRemove } from "./customCart/removeCart";
export { default as customClearCart } from "./customCart/clearCart";
export { default as customShipping } from "./customShipping/index";
export { default as customUpdateaddress } from "./customShipping/updateaddress";
export { default as customDeleteAddress } from "./customShipping/deleteaddress";
export { default as wishAdd } from "./wishAdd/";
export { default as wishList } from "./wishList/";
export { default as wishDelete } from "./wishDelete/";
export { default as wishClear } from "./wishClear/";
export { default as goodInfo } from "./goodInfo/";
export { default as subscribeList } from "./subscribeList/";
export { default as subscribeAdd } from "./subscribeAdd/";
export { default as subscribeDelete } from "./subscribeDelete/";
export { default as getCategory } from "./getCategory/";
export { default as customShippiingProvider } from "./shippiingProvider/load";
export { default as customPayMethods } from "./payMethod/";
export { default as orderPay } from "./order/pay";
export { default as orderPreview } from "./order/preview";
export { default as orderList } from "./order/list";
export { default as orderApply } from "./order/aftersales";
export { default as orderRefund } from "./order/refund";
export { default as orderSalesorder } from "./order/salesorder";
export { default as orderQuery } from "./order/query";
export { default as shopView } from "./shopView/";
export { default as constomUpUser } from "./customUpUser/";
export { default as customAddReview } from "./customReview/addreview";
export { default as customOrderReview } from "./customReview/index";
export { default as customPass } from "./customPass/";
export { default as configList } from "./configList/index";
export { default as artcleGet } from "./customartcle/index";
export { default as salesOrderList } from "./order/salesOrderList";
export { default as transAdd } from "./transAdd/index";
export { default as prepayList } from "./order/prepayList";
export { default as artcleOneGet } from "./customartcle/one";
export { default as getSameGoodList } from "./sameGoodList";
export { default as benefitCode } from "./order/benefitCode";
export { default as guojiaList } from "./guojiaList/index";
export { default as orderCreate } from "./order/create";
export { default as refreshToken } from "./customAuth/refreshToken";
export { default as customEmail } from "./customEmail/index";
export { default as EmailCode } from "./password/emailCode";
export { default as resetPassword } from "./password/resetPass";
export { default as paymentCredential } from './order/paymentCredential';
export { default as payerUpdate } from './order/payerUpdate';
export { default as shopConfig } from './shopConfig/index';
export { default as getXml } from './getXml/index';
export { default as shopConfigAll } from './shopConfigAll/index';
export { default as configAll } from './configList/all';
export { default as ArtcleList } from './articleList/index';
export { default as ArtcleCatList } from './articleCat/index';
export { default as phoneVerify } from './phoneVerify/index';
export { default as emailVerify} from './emailVerify/index';
export { default as wayBillList } from './wayBill/index';
export { default as guestLogin } from './guestLogin/index';
export { default as memberBenefitCodeList } from './benefitCode/index';
export { default as BenefitCodeOperates } from './benefitCode/operate';
export { default as setToken } from './guestLogin/setToken';
export { default as guestGetToken } from './guestLogin/getToken';
export { default as getCategoryTree } from './catTree/index';
export { default as getProvince } from './getProvince/index';
export { default as getDiscount } from './goodDiscount/index';
export { default as getGoodPostage } from './goodPostFee/index';
export { default as claimBenefitCode } from './claimBenefitCode/index';
export { default as prepayDetail } from './preDetail/index';
export { default as orderClose } from './order/close';
export { default as UnReadMessageList } from './message/index';
export { default as ReadMessage } from './message/read';
export { default as orderDetail } from './order/detail';
export { default as orderAfterSalesApply } from './order/aterSalesApply';
export { default as distributorAdd } from './distributor/add';
export { default as distributorList } from './distributor/list';
export { default as distributorOrderList } from './distributor/order';
export { default as productSearch } from './productSearch';
export { default as goodWholesaleGet } from './wholesale/index';
export { default as goodCommentLevel } from './goodCommentLevel/index';
export { default as orderCheckoutDetails } from './order/checkoutDetails';
export { default as orderPaymentMethod } from './payMethod/orderPayment';
export { default as CouponList } from './customCoupon/index';
export { default as orderReceiving } from './order/receiving';
